// example:
//
// <div x-data="imageSelector()">
//   <div x-ref="imageContainer">
//   </div>
//   <input type="file" @change="selectImage">
//   <input type="checkbox" x-ref="removeCheckbox" @change="remove">
// </div>


export default () => ({
  empty: true,

  init() {
    if (this.$refs.imageContainer.children.length > 0) {
      this.empty = false
    }
  },

  selectImage(e) {
    const file = e.target.files[0]
    const image = document.createElement('img')
    image.src = URL.createObjectURL(file)
    this.$refs.imageContainer.innerHTML = ''
    this.$refs.imageContainer.appendChild(image)
    this.empty = false
    this.$refs.removeCheckbox.checked = false
  },

  remove() {
    this.$refs.imageContainer.innerHTML = ''
    this.empty = true
  }
})
